import { useSelector } from 'react-redux';
import { selectUserVerificationLevel } from '@homeplay/app';
import { useLastVerificationStatus } from '@homeplay/hooks';
import { PassedIcon } from '@homeplay/components/src/UI/icons';
import { StatusLabel } from '@homeplay/components/src/UI/labels';
import { VerificationButton } from '../VerificationButton';
import classes from './VerificationStatus.module.scss';

const VerificationStatus = () => {
  const currentVerificationLevel = useSelector(selectUserVerificationLevel);
  const { isVerificationPending, isLoading } = useLastVerificationStatus();

  const renderVerificationAction = (requiredVerificationLevel) => {
    if (isLoading) {
      return null;
    }

    return isVerificationPending ? (
      <StatusLabel variant="pending" />
    ) : (
      <VerificationButton
        requiredVerificationLevel={requiredVerificationLevel}
      />
    );
  };

  switch (currentVerificationLevel) {
    case 1:
      return renderVerificationAction(2);

    case 2:
      return (
        <div className={`${classes.statusWrapper} color-primary semi-bold`}>
          <span>Standard</span>
          <PassedIcon />
          {renderVerificationAction(3)}
        </div>
      );

    case 3:
      return (
        <div className={`${classes.statusWrapper} color-primary semi-bold`}>
          <span>Advanced</span>
          <PassedIcon />
        </div>
      );

    default:
      return 'Unknown';
  }
};

export default VerificationStatus;
